import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, Table } from "semantic-ui-react";
import { getTranslate } from "react-localize-redux";
import { getProducts } from "../../../../reducer";


class ProductsTable extends Component {
    render() {
        return (
            <Table celled>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>{this.props.translate("inventory.table.header.code")}</Table.HeaderCell>
                        <Table.HeaderCell>{this.props.translate("tools.fields.name")}</Table.HeaderCell>
                        <Table.HeaderCell>{this.props.translate("inventory.table.header.size")}</Table.HeaderCell>
                        <Table.HeaderCell>{this.props.translate("inventory.table.header.vintage")}</Table.HeaderCell>
                        <Table.HeaderCell>{this.props.translate("inventory.table.header.box")}</Table.HeaderCell>
                        <Table.HeaderCell>{this.props.translate("manage.fields.action")}</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {this.props.products.filter((p) => {
                        return p.type !== "MATRIX";
                    })
                        .sort((a, b) => {
                            if (typeof a.variations[0] === "undefined") {
                                return 1;
                            }

                            if (typeof b.variations[0] === "undefined") {
                                return -1;
                            }

                            return Number.parseInt(a.variations[0].code, 10) - Number.parseInt(b.variations[0].code, 10) === 0 ?
                                Number.parseInt(a.variations[1].code, 10) - Number.parseInt(b.variations[1].code, 10) :
                                Number.parseInt(a.variations[0].code, 10) - Number.parseInt(b.variations[0].code, 10);
                        })
                        .map((product) => {

                                let variations = product.variations;

                                if (variations) {
                                    variations = variations.sort((a, b) => {
                                        if (a.pivot.dimensionOrder > b.pivot.dimensionOrder) {
                                            return 1;
                                        }
                                        return -1;
                                    });
                                }

                                product.variations = variations;

                                return <Table.Row
                                    key={product.id}
                                    disabled={product.remoteSynced === 1}
                                >
                                    <Table.Cell>{product.code}</Table.Cell>
                                    <Table.Cell>{product.name}</Table.Cell>
                                    <Table.Cell>{(this.props.noMatrix || typeof variations === "undefined" || typeof variations[0] === "undefined") ? "-" : variations[0].code}</Table.Cell>
                                    <Table.Cell>{(this.props.noMatrix || typeof variations === "undefined" || typeof variations[1] === "undefined") ? "-" : variations[1].code}</Table.Cell>
                                    <Table.Cell>{(this.props.noMatrix || typeof variations === "undefined" || typeof variations[2] === "undefined") ? "-" : variations[2].code}</Table.Cell>
                                    <Table.Cell>
                                        {product.remoteSynced === 1 ?

                                            <div>"Currently disabled - products are resyncing"</div> :
                                            <Button.Group fluid>
                                                <Button primary onClick={() => {
                                                    this.props.productSelected(product);
                                                }}>
                                                    {this.props.translate("tools.general.choose")}
                                                </Button>

                                            </Button.Group>

                                        }

                                    </Table.Cell>
                                </Table.Row>;

                            }
                        )}
                </Table.Body>
            </Table>
        );
    }
}

const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
    products: getProducts(state.tools),
});


const mapDispatchToProps = (dispatch) => {
    return ({});
};


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ProductsTable);



// WEBPACK FOOTER //
// ./src/scenes/Tools/scenes/MasterDataRequest/components/ProductsTable/index.js